import React from 'react'

import { useChangePasswordForm } from './useResetPasswordForm'
import { FormField } from 'components/Inputs'
import Button from 'components/Button'
import AlertGroup from 'components/AlertGroup'
import alertMessages from 'lib/enums/alertMessages'

const ChangePassword = () => {
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    errors,
    touched,
    isSubmitting,
    status,
  } = useChangePasswordForm()

  return (
    <div>
      <h1 className='text-1.5xl text-brand-900 font-bold tracking-wide mb-4'>
        Change password
      </h1>
      <p className='text-xs font-inter text-brand-900 font-light mb-8'>
        Enter your desired password
      </p>
      <div>
        <form onSubmit={handleSubmit}>
          {status?.error ? (
            <AlertGroup alert={alertMessages[status?.error?.message]} />
          ) : null}
          <div className='space-y-8'>
            <div className='space-y-4.5'>
              <FormField
                id='password'
                name='password'
                label='New Password'
                placeholder='••••••••'
                type='password'
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.password}
                error={touched.password && errors.password}
              />
              <FormField
                id='passwordConfirmation'
                name='passwordConfirmation'
                label='Confirm new password'
                placeholder='••••••••'
                type='password'
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.passwordConfirmation}
                error={
                  touched.passwordConfirmation && errors.passwordConfirmation
                }
              />
            </div>

            <Button
              type='submit'
              className='w-full'
              disabled={isSubmitting}
              loading={isSubmitting}
              hasIcon>
              <span>Submit</span>
            </Button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default ChangePassword
